<div class="content-detail">
  <div class="header-container">
    <h2>{{ "master-tenant.title" | translate }}</h2>
    <button mat-raised-button color="primary" (click)="openAddDialog()">
      {{ "master-tenant.addNewTenant" | translate }}
    </button>
  </div>
  <div class="table-content">
    <table class="table table-bordered text-center">
      <thead>
        <tr>
          <th>{{ "master-tenant.activeStatus" | translate }}</th>
          <th>{{ "master-tenant.tenantName" | translate }}</th>
          <th>{{ "master-tenant.aka" | translate }}</th>
          <th>{{ "master-tenant.subIndustry" | translate }}</th>
          <!--           <th>{{ "master-tenant.country" | translate }}</th>
          <th>{{ "master-tenant.contact" | translate }}</th> -->
          <th>{{ "master-tenant.tenantStatus" | translate }}</th>
          <th *ngIf="currentCode == 'mx'">
            {{ "master-tenant.tag" | translate }}
          </th>
          <th>{{ "master-tenant.dateCreated" | translate }}</th>
          <th>{{ "master-tenant.upadateCreated" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <select
              [(ngModel)]="filterActiveStatus"
              (change)="onInputChange()"
              class="form-select margin-filter"
            >
              <option [ngValue]="null">{{
                "master-tenant.all" | translate
              }}</option>
              <option [ngValue]="'Active'"
                >{{ "master-tenant.active" | translate }}
              </option>
              <option [ngValue]="'Inactive'">{{
                "master-tenant.inactive" | translate
              }}</option>
              <option [ngValue]="'Pending'">{{
                "master-tenant.pending" | translate
              }}</option>
              <option [ngValue]="'InactiveMerged'">{{
                "master-tenant.inactiveMerged" | translate
              }}</option>
            </select>
          </td>
          <td>
            <input
              type="text"
              [(ngModel)]="filterName"
              (ngModelChange)="onInputChange()"
              [placeholder]="'master-tenant.filterByName' | translate"
              class="form-control margin-filter"
            />
          </td>
          <td></td>
          <td>
            <select
              [(ngModel)]="filterIndustry"
              (change)="onInputChange()"
              class="form-select margin-filter"
            >
              <option [ngValue]="null">{{
                "master-tenant.industryOption" | translate
              }}</option>
              <option *ngFor="let industry of industries" [value]="industry.id"
                >{{ industry.name | langSelector }}
              </option>
            </select>
          </td>
          <!-- <td>
            <select
              [(ngModel)]="filterCountry"
              (change)="onInputChange()"
              class="form-select margin-filter"
            >
              <option [ngValue]="null">{{
                "master-tenant.industryOption" | translate
              }}</option>
              <option [ngValue]="''">{{
                "master-tenant.none" | translate
              }}</option>
              <option *ngFor="let country of countries" [value]="country">{{
                country
              }}</option>
            </select>
          </td>
          <td>
            <select
              [(ngModel)]="filterContact"
              (change)="onInputChange()"
              class="form-select margin-filter"
            >
              <option [ngValue]="null">{{
                "master-tenant.industryOption" | translate
              }}</option>
              <option [ngValue]="true"
                >{{ "master-tenant.yes" | translate }}
              </option>
              <option [ngValue]="false">{{
                "master-tenant.no" | translate
              }}</option>
            </select>
          </td> -->
          <td>
            <select
              [(ngModel)]="filterStatus"
              (change)="onInputChange()"
              class="form-select margin-filter"
            >
              <option [ngValue]="null">{{
                "master-tenant.industryOption" | translate
              }}</option>
              <option [ngValue]="true"
                >{{ "master-tenant.stats" | translate }}
              </option>
              <option [ngValue]="false">{{
                "master-tenant.noStats" | translate
              }}</option>
            </select>
          </td>
          <td *ngIf="currentCode == 'mx'">
            <select
              class="form-select margin-filter"
              (change)="onInputChange()"
              [(ngModel)]="filterParentCorporationValue"
            >
              <option
                *ngFor="let parentCorporationValue of parentCorporationList"
                [value]="parentCorporationValue"
              >
                {{ "PROPERTY_TYPES." + parentCorporationValue | translate }}
              </option>
            </select>
          </td>
          <td style="overflow: visible;">
            <div
              class="position-relative margin-filter date-filter"
              #createdFilterRef
            >
              <button
                type="button"
                class="form-control date-filter-trigger"
                (click)="toggleDropdown('created', $event)"
              >
                <span class="date-filter-text">
                  {{ getDateFilterSummary("created") }}
                </span>
                <span class="date-filter-icon">
                  {{ showDropdown ? "-" : "+" }}
                </span>
              </button>
              <div class="date-filter-dropdown" *ngIf="showDropdown">
                <div
                  class="date-filter-year"
                  *ngFor="let yearNode of createdDateFilterNodes"
                >
                  <div class="date-filter-year-header">
                    <button
                      type="button"
                      class="toggle-icon"
                      (click)="toggleYearExpansion(yearNode, $event)"
                    >
                      {{ yearNode.expanded ? "-" : "+" }}
                    </button>
                    <input
                      type="checkbox"
                      [checked]="yearNode.checked"
                      [indeterminate]="yearNode.indeterminate"
                      (change)="
                        onYearSelectionChange('created', yearNode, $event)
                      "
                    />
                    <span class="year-label">{{ yearNode.year }}</span>
                  </div>
                  <div class="date-filter-months" *ngIf="yearNode.expanded">
                    <label
                      class="month-option"
                      *ngFor="let month of yearNode.months"
                    >
                      <input
                        type="checkbox"
                        [checked]="month.checked"
                        (change)="
                          onMonthSelectionChange(
                            'created',
                            yearNode,
                            month,
                            $event
                          )
                        "
                      />
                      <span>{{ month.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td style="overflow: visible;">
            <div
              class="position-relative margin-filter date-filter"
              #updatedFilterRef
            >
              <button
                type="button"
                class="form-control date-filter-trigger"
                (click)="toggleDropdown('updated', $event)"
              >
                <span class="date-filter-text">
                  {{ getDateFilterSummary("updated") }}
                </span>
                <span class="date-filter-icon">
                  {{ showDropdownModifiedDate ? "-" : "+" }}
                </span>
              </button>
              <div
                class="date-filter-dropdown"
                *ngIf="showDropdownModifiedDate"
              >
                <div
                  class="date-filter-year"
                  *ngFor="let yearNode of updatedDateFilterNodes"
                >
                  <div class="date-filter-year-header">
                    <button
                      type="button"
                      class="toggle-icon"
                      (click)="toggleYearExpansion(yearNode, $event)"
                    >
                      {{ yearNode.expanded ? "-" : "+" }}
                    </button>
                    <input
                      type="checkbox"
                      [checked]="yearNode.checked"
                      [indeterminate]="yearNode.indeterminate"
                      (change)="
                        onYearSelectionChange('updated', yearNode, $event)
                      "
                    />
                    <span class="year-label">{{ yearNode.year }}</span>
                  </div>
                  <div class="date-filter-months" *ngIf="yearNode.expanded">
                    <label
                      class="month-option"
                      *ngFor="let month of yearNode.months"
                    >
                      <input
                        type="checkbox"
                        [checked]="month.checked"
                        (change)="
                          onMonthSelectionChange(
                            'updated',
                            yearNode,
                            month,
                            $event
                          )
                        "
                      />
                      <span>{{ month.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>

        <tr *ngFor="let tenant of tenants">
          <td>
            {{
              tenant?.status == "Active"
                ? ("master-tenant.active" | translate)
                : tenant?.status == "Inactive"
                ? ("master-tenant.inactive" | translate)
                : tenant?.status == "InactiveMerged"
                ? ("master-tenant.inactiveMerged" | translate)
                : ("master-tenant.pending" | translate)
            }}
          </td>
          <td class="align-column">
            <mat-icon (click)="editTenant(tenant)">edit</mat-icon>
            <span>{{ tenant?.name }}</span>
          </td>
          <td>
            {{ tenant?.aka }}
          </td>
          <td>
            {{
              currentCode == "mx" && tenant?.corporationPropertyType == "RETAIL"
                ? (tenant?.industryRetail?.name | langSelector)
                : (tenant?.industry?.name | langSelector)
            }}
          </td>
          <!-- <td>{{ tenant?.country }}</td>
          <td>
            {{
              validateContact(tenant)
                ? ("master-tenant.yes" | translate)
                : ("master-tenant.no" | translate)
            }}
          </td> -->
          <td>
            {{
              tenant?.includedInStats
                ? ("master-tenant.stats" | translate)
                : ("master-tenant.noStats" | translate)
            }}
          </td>
          <td *ngIf="currentCode == 'mx'">
            {{ tenant?.corporationPropertyType }}
          </td>
          <td>{{ tenant?.createdDate }}</td>
          <td>{{ tenant?.modifiedDate }}</td>
        </tr>
      </tbody>
    </table>
    <ngb-pagination
      [collectionSize]="total"
      [(page)]="page"
      [pageSize]="perPage"
      [maxSize]="5"
      (pageChange)="onPageChange($event)"
    ></ngb-pagination>
  </div>
</div>
